const brands = [];
const currentProductTypology = document.getElementById('mm-moto-current-product').value;
const brandSelect = document.getElementById('mm-moto-marque-select');
const modelSelect = document.getElementById('mm-moto-modele-select');
const modelSelectText = modelSelect.dataset.selectText;
const validateModel = document.querySelector('.mm-moto-submit');
const motoCompatibilityTrue = document.getElementById('mm-moto-compatibility-true');
const motoCompatibilityFalse = document.getElementById('mm-moto-compatibility-false');
const motoResult = document.getElementById('mm-moto-result');
const motoProductsData = document.querySelectorAll('.mm-moto-product');
const motoError = document.getElementById('mm-moto-error');
const sorryText = document.getElementById('mm-moto-sorry-text').innerHTML;
const endStep1 = document.querySelector('.mm-moto-modal-end-step-1');
const endStep2 = document.querySelector('.mm-moto-modal-end-step-2');
const endStep3 = document.querySelector('.mm-moto-modal-end-step-3');


// SPLIDE RECOS
var id = '.splide-moto-result';
var splideElem = document.querySelector(id);
var splideRecos;

document.addEventListener("DOMContentLoaded", (event) => {
  splideRecos = new Splide( splideElem, {
    type   : 'splide',
    arrows: true,
    pagination: false,
    rewind: true,
    gap: 20,
    perPage: 1
  })
  splideRecos.mount();
});


function onlyUnique(value, index, array) {
  return array.indexOf(value) === index;
}

function mmCloseMotoModal() {
  // mmSizeBrandInit();
  document.querySelector('.mm-moto-modal-wrapper').classList.remove('mm-visible');
  updateTextButton(false);
}

function mmOpenMotoModal() {
  if(localStorage.getItem("Moto_model")){
  } else {
    mmRefreshModal();
  }
  document.querySelector('.mm-moto-modal-wrapper').classList.add('mm-visible');
}

function mmRefreshModal() {
  brandSelect.selectedIndex = 0;
  modelSelect.selectedIndex = 0;
  if(motoCompatibilityTrue){motoCompatibilityTrue.style.display = 'none'};
  if(motoCompatibilityFalse){motoCompatibilityFalse.style.display = 'none'};
  motoResult.innerHTML = "";
  endStep1.style.display = 'block';
  endStep2.style.display = 'none';
  endStep3.style.display = 'none';
}

parseJson();

function mmUpdateCTA(is_compatible, brand, model) {
  // Set item
  localStorage.setItem("Moto_model", `${brand} - ${model}`);

  var button = document.querySelector('#product-form .mm-moto-modal-button');
  var buttons = document.querySelectorAll("#product-form .mm-moto-modal-button");

  console.log(buttons)

  if(buttons) {
    buttons.forEach(button => {
      if(is_compatible){
        button.outerHTML = `
          <span class="mm-moto-modal-button mm-moto-cta-compatible" id="mmMotoModalButton">
            <p onclick="mmOpenMotoModal()">${brand} - ${model}</p>
            <svg onclick="forgetUserChoice()" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="white" class="w-6 h-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </span>
        `;
      } else {
        button.outerHTML = `
          <span class="mm-moto-modal-button mm-moto-cta-not-compatible" id="mmMotoModalButton">
            <p onclick="mmOpenMotoModal()">${brand} - ${model}</p>
            <svg onclick="forgetUserChoice()" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="white" class="w-6 h-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </span>
        `;
      }
    });
  }

  const selectedCard = document.querySelector('.mm-selector-support-product .mm-selector-card-selected');
  const supportContainer = document.querySelector('.mm-selector-support-container');

  if (selectedCard && supportContainer) {
    const sizeBanner = selectedCard.querySelector('.mm-selector-card-size');

    if (sizeBanner) {
      const compatibleText = supportContainer.getAttribute('data-comptabile');
      const notCompatibleText = supportContainer.getAttribute('data-no-comptabile');

      if (is_compatible) {
        sizeBanner.textContent = compatibleText;
      } else {
        sizeBanner.textContent = notCompatibleText;
      }
    } else {
      console.log('Élément .mm-selector-card-size non trouvé dans la carte sélectionnée.');
    }
  } else {
    console.log('Carte sélectionnée ou conteneur support non trouvé.');
  }


  
}

// Parse JSON
function parseJson() {
  var json = document.querySelector('.moto-metafield-json');
  JSON.parse(json.innerText).map((modelData) => {
    brands.push({
      brand: modelData.Marque
    });
  });

  var brands_unique = [...new Set(brands.map(item => item.brand))];
  brands_unique.forEach(function(brand){
    var htmlElement = `<option value="${brand.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')}">${brand}</option>`;
    brandSelect.insertAdjacentHTML('beforeend', htmlElement);
  })

  brandSelect.addEventListener('change', function(e){
    var models = [];
    JSON.parse(json.innerText).map((modelData) => {
      if(modelData.Marque == brandSelect.options[brandSelect.selectedIndex].text){
        models.push({
          model: modelData.Modèle,
          reco: modelData.Recommandation,
          moto: modelData['Moto'],
          argumoto: modelData['Texte argu Moto'],
          motopro: modelData['Moto Pro'],
          argumotopro: modelData['Texte argu Moto Pro'],
          motoproboost: modelData['Moto Pro Boost'],
          argumotoproboost: modelData['Texte argu Moto Pro Boost'],
          motostem: modelData['Moto Stem'],
          argumotostem: modelData['Texte argu Moto Stem'],
          motostemboost: modelData['Moto Stem Boost'],
          argumotostemboost: modelData['Texte argu Moto Stem Boost'],
          mirror: modelData['Mirror'],
          argumirror: modelData['Texte argu Mirror'],
          mirrorpro: modelData['Mirror Pro'],
          argumirrorpro: modelData['Texte argu Mirror Pro'],
          scooterscrew: modelData['Scooter Screw'],
          arguscooterscrew: modelData['Texte argu Scooter Screw'],
          proboosttu: modelData['Pro Boost TU'],
          arguproboosttu: modelData['Texte argu Pro Boost TU'],
          protu: modelData['Pro Tu'],
          arguprotu: modelData['Texte argu Pro Tu'],
          mototu: modelData['Moto Tu'],
          argumototu: modelData['Texte argu Moto Tu'],
          motostemboostmini: modelData['Moto Stem Boost Mini'],
          argumotostemboostmini: modelData['Texte argu Moto Stem Boost Mini']
        })
      }
    });
    modelSelect.innerHTML = `<option value="" id="mm-moto-model-empty">${modelSelectText}</option>`;
    models.forEach(function(model){
      var htmlElement = `
      <option value="${model.model.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')}"
        data-moto="${model.moto}"
        data-argumoto="${model.argumoto}"
        data-motopro="${model.motopro}"
        data-argumotopro="${model.argumotopro}"
        data-motoproboost="${model.motoproboost}"
        data-argumotoproboost="${model.argumotoproboost}"
        data-motostem="${model.motostem}"
        data-argumotostem="${model.argumotostem}"
        data-motostemboost="${model.motostemboost}"
        data-argumotostemboost="${model.argumotostemboost}"
        data-mirror="${model.mirror}"
        data-argumirror="${model.argumirror}"
        data-mirrorpro="${model.mirrorpro}"
        data-argumirrorpro="${model.argumirrorpro}"
        data-scooterscrew="${model.scooterscrew}"
        data-arguscooterscrew="${model.arguscooterscrew}"
        data-proboosttu="${model.proboosttu}"
        data-arguproboosttu="${model.arguproboosttu}"
        data-protu="${model.protu}"
        data-arguprotu="${model.arguprotu}"
        data-mototu="${model.mototu}"
        data-argumototu="${model.argumototu}"
        data-motostemboostmini="${model.motostemboostmini}"
        data-argumotostemboostmini="${model.argumotostemboostmini}"
        data-reco="${model.reco}">
          ${model.model}
      </option>`;
      modelSelect.insertAdjacentHTML('beforeend', htmlElement);
    })
  })

  validateModel.addEventListener('click', function(e){

    motoError.style.display = 'none';
    if (brandSelect.selectedIndex == 0 || modelSelect.selectedIndex == 0) {
      motoError.style.display = 'block';
      if(motoCompatibilityTrue){motoCompatibilityTrue.style.display = 'none'}
      if(motoCompatibilityFalse){motoCompatibilityFalse.style.display = 'none'}
      motoResult.innerHTML = "";
    } else {

      // Set LocalStorage
      localStorage.setItem("compatibility_moto", modelSelect.options[modelSelect.selectedIndex].dataset['moto']);
      localStorage.setItem("compatibility_motopro", modelSelect.options[modelSelect.selectedIndex].dataset['motopro']);
      localStorage.setItem("compatibility_motoproboost", modelSelect.options[modelSelect.selectedIndex].dataset['motoproboost']);
      localStorage.setItem("compatibility_motostem", modelSelect.options[modelSelect.selectedIndex].dataset['motostem']);
      localStorage.setItem("compatibility_motostemboost", modelSelect.options[modelSelect.selectedIndex].dataset['motostemboost']);
      localStorage.setItem("compatibility_mirror", modelSelect.options[modelSelect.selectedIndex].dataset['mirror']);
      localStorage.setItem("compatibility_mirrorpro", modelSelect.options[modelSelect.selectedIndex].dataset['mirrorpro']);
      localStorage.setItem("compatibility_scooterscrew", modelSelect.options[modelSelect.selectedIndex].dataset['scooterscrew']);
      localStorage.setItem("compatibility_scooterscrew", modelSelect.options[modelSelect.selectedIndex].dataset['scooterscrew']);
      localStorage.setItem("compatibility_proboosttu", modelSelect.options[modelSelect.selectedIndex].dataset['proboosttu']);
      localStorage.setItem("compatibility_proboosttu", modelSelect.options[modelSelect.selectedIndex].dataset['argumototu']);
      localStorage.setItem("compatibility_proboosttu", modelSelect.options[modelSelect.selectedIndex].dataset['motostemboostmini']);
      localStorage.setItem("compatibility_proboosttu", modelSelect.options[modelSelect.selectedIndex].dataset['argumotostemboostmini']);



      var currentProductTypologyTrim = currentProductTypology.toLowerCase().replace(/\s/g, '');

      if(modelSelect.options[modelSelect.selectedIndex].dataset[currentProductTypologyTrim] == "OUI") {
        if(motoCompatibilityTrue){
          motoCompatibilityTrue.style.display = 'block';
          // mettre aussi le bandeau 'compatible' en display block
        }
        if(motoCompatibilityFalse){
          motoCompatibilityFalse.style.display = 'none';
          // mettre aussi le bandeau 'non compatible' en display block
        }
        mmUpdateCTA(true, brandSelect.options[brandSelect.selectedIndex].innerText, modelSelect.options[modelSelect.selectedIndex].innerText);
      } else {
        if(motoCompatibilityTrue){motoCompatibilityTrue.style.display = 'none'}
        if(motoCompatibilityFalse){motoCompatibilityFalse.style.display = 'block'}
        mmUpdateCTA(false, brandSelect.options[brandSelect.selectedIndex].innerText, modelSelect.options[modelSelect.selectedIndex].innerText);
      }

      motoResult.innerHTML = "";

      // FIRST RECO
      var counter = 0;
      motoProductsData.forEach(function(motoProductData){
        var datasetArgu = 'argu' + modelSelect.options[modelSelect.selectedIndex].dataset.reco.toLowerCase().replace(/\s/g, '');
        if(modelSelect.options[modelSelect.selectedIndex].dataset.reco.toLowerCase() == motoProductData.dataset.name.toLowerCase()) {
			counter += 1;
			var recoProductCard = `
          <li class="splide__slide mm-moto-reco-card">
            <img src="${motoProductData.dataset.image}">
            <div class="mm-moto-reco-card-content">
              <p class="mm-moto-reco-card-title">${motoProductData.dataset.title}</p>
              <p class="mm-moto-reco-card-price">${motoProductData.dataset.price} <span>${motoProductData.dataset.freeShipping}</span></p>
              <a href="${motoProductData.dataset.url}" class="mm-btn-primary">${motoProductData.dataset.ctaSee}</a>
            </div>
            <p class="mm-moto-reco-card-argu">${motoProductData.dataset.compatibleTxt}</p>
          </li>
          `;
			// Replace <p class="mm-moto-reco-card-argu">${modelSelect.options[modelSelect.selectedIndex].dataset[datasetArgu]}</p> by <p class="mm-moto-reco-card-argu">${motoProductData.dataset.compatibleTxt}</p>
			motoResult.insertAdjacentHTML("beforeend", recoProductCard);
		} else if (modelSelect.options[modelSelect.selectedIndex].dataset.reco.toLowerCase() == "aucun") {
          motoResult.innerHTML = `
          <div class="mm-moto-result-aucun">
          ${sorryText}
          </div>
          <style>.splide-moto-result .splide__arrows {display:none}</style>
          `
        }
      })

      // 2ND and 3RD RECO
      motoProductsData.forEach(function(motoProductData){
        // MOTO
        if(modelSelect.options[modelSelect.selectedIndex].dataset.moto == "OUI") {
          if(modelSelect.options[modelSelect.selectedIndex].dataset.reco.toLowerCase() != "moto") {
            if(motoProductData.dataset.name == "Moto") {
              if (counter < 4) {
                counter += 1;
                var recoProductCard = `
                  <li class="splide__slide mm-moto-reco-card">
                    <img src="${motoProductData.dataset.image}">
                    <div class="mm-moto-reco-card-content">
                      <p class="mm-moto-reco-card-title">${motoProductData.dataset.title}</p>
                      <p class="mm-moto-reco-card-price">${motoProductData.dataset.price} <span>${motoProductData.dataset.freeShipping}</span></p>
                      <a href="${motoProductData.dataset.url}" class="mm-btn-primary">${motoProductData.dataset.ctaSee}</a>
                    </div>
                    <p class="mm-moto-reco-card-argu">${modelSelect.options[modelSelect.selectedIndex].dataset.argumoto}</p>
                  </li>
                `;
                motoResult.insertAdjacentHTML('beforeend', recoProductCard);
              }
            }
          }
        }
        // MOTO PRO
        if(modelSelect.options[modelSelect.selectedIndex].dataset.motopro == "OUI") {
          if(modelSelect.options[modelSelect.selectedIndex].dataset.reco.toLowerCase() != "moto pro") {
            if(motoProductData.dataset.name == "Moto Pro") {
              if (counter < 4) {
                counter += 1;
                var recoProductCard = `
                  <li class="splide__slide mm-moto-reco-card">
                    <img src="${motoProductData.dataset.image}">
                    <div class="mm-moto-reco-card-content">
                      <p class="mm-moto-reco-card-title">${motoProductData.dataset.title}</p>
                      <p class="mm-moto-reco-card-price">${motoProductData.dataset.price} <span>${motoProductData.dataset.freeShipping}</span></p>
                      <a href="${motoProductData.dataset.url}" class="mm-btn-primary">${motoProductData.dataset.ctaSee}</a>
                    </div>
                    <p class="mm-moto-reco-card-argu">${modelSelect.options[modelSelect.selectedIndex].dataset.argumotopro}</p>
                  </li>
                `;
                motoResult.insertAdjacentHTML('beforeend', recoProductCard);
              }
            }
          }
        }
        // MOTO PRO BOOST
        if(modelSelect.options[modelSelect.selectedIndex].dataset.motoproboost == "OUI") {
          if(modelSelect.options[modelSelect.selectedIndex].dataset.reco.toLowerCase() != "moto pro boost") {
            if(motoProductData.dataset.name == "Moto Pro Boost") {
              if (counter < 4) {
                counter += 1;
                var recoProductCard = `
                  <li class="splide__slide mm-moto-reco-card">
                    <img src="${motoProductData.dataset.image}">
                    <div class="mm-moto-reco-card-content">
                      <p class="mm-moto-reco-card-title">${motoProductData.dataset.title}</p>
                      <p class="mm-moto-reco-card-price">${motoProductData.dataset.price} <span>${motoProductData.dataset.freeShipping}</span></p>
                      <a href="${motoProductData.dataset.url}" class="mm-btn-primary">${motoProductData.dataset.ctaSee}</a>
                    </div>
                    <p class="mm-moto-reco-card-argu">${modelSelect.options[modelSelect.selectedIndex].dataset.argumotoproboost}</p>
                  </li>
                `;
                motoResult.insertAdjacentHTML('beforeend', recoProductCard);
              }
            }
          }
        }
        // MOTO STEM
        if(modelSelect.options[modelSelect.selectedIndex].dataset.motostem == "OUI") {
          if(modelSelect.options[modelSelect.selectedIndex].dataset.reco.toLowerCase() != "moto stem") {
            if(motoProductData.dataset.name == "Moto Stem") {
              if (counter < 4) {
                counter += 1;
                var recoProductCard = `
                  <li class="splide__slide mm-moto-reco-card">
                    <img src="${motoProductData.dataset.image}">
                    <div class="mm-moto-reco-card-content">
                      <p class="mm-moto-reco-card-title">${motoProductData.dataset.title}</p>
                      <p class="mm-moto-reco-card-price">${motoProductData.dataset.price} <span>${motoProductData.dataset.freeShipping}</span></p>
                      <a href="${motoProductData.dataset.url}" class="mm-btn-primary">${motoProductData.dataset.ctaSee}</a>
                    </div>
                    <p class="mm-moto-reco-card-argu">${modelSelect.options[modelSelect.selectedIndex].dataset.argumotostem}</p>
                  </li>
                `;
                motoResult.insertAdjacentHTML('beforeend', recoProductCard);
              }
            }
          }
        }
        // MOTO STEM BOOST
        if(modelSelect.options[modelSelect.selectedIndex].dataset.motostemboost == "OUI") {
          if(modelSelect.options[modelSelect.selectedIndex].dataset.reco.toLowerCase() != "moto stem boost") {
            if(motoProductData.dataset.name == "Moto Stem Boost") {
              if (counter < 4) {
                counter += 1;
                var recoProductCard = `
                  <li class="splide__slide mm-moto-reco-card">
                    <img src="${motoProductData.dataset.image}">
                    <div class="mm-moto-reco-card-content">
                      <p class="mm-moto-reco-card-title">${motoProductData.dataset.title}</p>
                      <p class="mm-moto-reco-card-price">${motoProductData.dataset.price} <span>${motoProductData.dataset.freeShipping}</span></p>
                      <a href="${motoProductData.dataset.url}" class="mm-btn-primary">${motoProductData.dataset.ctaSee}</a>
                    </div>
                    <p class="mm-moto-reco-card-argu">${modelSelect.options[modelSelect.selectedIndex].dataset.argumotostemboost}</p>
                  </li>
                `;
                motoResult.insertAdjacentHTML('beforeend', recoProductCard);
              }
            }
          }
        }
        // MIRROR
        if(modelSelect.options[modelSelect.selectedIndex].dataset.mirror == "OUI") {
          if(modelSelect.options[modelSelect.selectedIndex].dataset.reco.toLowerCase() != "mirror") {
            if(motoProductData.dataset.name == "Mirror") {
              if (counter < 4) {
                counter += 1;
                var recoProductCard = `
                  <li class="splide__slide mm-moto-reco-card">
                    <img src="${motoProductData.dataset.image}">
                    <div class="mm-moto-reco-card-content">
                      <p class="mm-moto-reco-card-title">${motoProductData.dataset.title}</p>
                      <p class="mm-moto-reco-card-price">${motoProductData.dataset.price} <span>${motoProductData.dataset.freeShipping}</span></p>
                      <a href="${motoProductData.dataset.url}" class="mm-btn-primary">${motoProductData.dataset.ctaSee}</a>
                    </div>
                    <p class="mm-moto-reco-card-argu">${modelSelect.options[modelSelect.selectedIndex].dataset.argumirror}</p>
                  </li>
                `;
                motoResult.insertAdjacentHTML('beforeend', recoProductCard);
              }
            }
          }
        }
        // MIRROR PRO
        if(modelSelect.options[modelSelect.selectedIndex].dataset.mirrorpro == "OUI") {
          if(modelSelect.options[modelSelect.selectedIndex].dataset.reco.toLowerCase() != "mirror pro") {
            if(motoProductData.dataset.name == "Mirror Pro") {
              if (counter < 4) {
                counter += 1;
                var recoProductCard = `
                  <li class="splide__slide mm-moto-reco-card">
                    <img src="${motoProductData.dataset.image}">
                    <div class="mm-moto-reco-card-content">
                      <p class="mm-moto-reco-card-title">${motoProductData.dataset.title}</p>
                      <p class="mm-moto-reco-card-price">${motoProductData.dataset.price} <span>${motoProductData.dataset.freeShipping}</span></p>
                      <a href="${motoProductData.dataset.url}" class="mm-btn-primary">${motoProductData.dataset.ctaSee}</a>
                    </div>
                    <p class="mm-moto-reco-card-argu">${modelSelect.options[modelSelect.selectedIndex].dataset.argumirrorpro}</p>
                  </li>
                `;
                motoResult.insertAdjacentHTML('beforeend', recoProductCard);
              }
            }
          }
        }
        // SCOOTER SCREW
        if(modelSelect.options[modelSelect.selectedIndex].dataset.scooterscrew == "OUI") {
          if(modelSelect.options[modelSelect.selectedIndex].dataset.reco.toLowerCase() != "scooter screw") {
            if(motoProductData.dataset.name == "Scooter Screw") {
              if (counter < 4) {
                counter += 1;
                var recoProductCard = `
                  <li class="splide__slide mm-moto-reco-card">
                    <img src="${motoProductData.dataset.image}">
                    <div class="mm-moto-reco-card-content">
                      <p class="mm-moto-reco-card-title">${motoProductData.dataset.title}</p>
                      <p class="mm-moto-reco-card-price">${motoProductData.dataset.price} <span>${motoProductData.dataset.freeShipping}</span></p>
                      <a href="${motoProductData.dataset.url}" class="mm-btn-primary">${motoProductData.dataset.ctaSee}</a>
                    </div>
                    <p class="mm-moto-reco-card-argu">${modelSelect.options[modelSelect.selectedIndex].dataset.arguscooterscrew}</p>
                  </li>
                `;
                motoResult.insertAdjacentHTML('beforeend', recoProductCard);
              }
            }
          }
        }
        // PRO BOOST TU
        if(modelSelect.options[modelSelect.selectedIndex].dataset.proboosttu == "OUI") {
          if(modelSelect.options[modelSelect.selectedIndex].dataset.reco.toLowerCase() != "pro boost tu") {
            if(motoProductData.dataset.name == "Pro Boost TU") {
              if (counter < 4) {
                counter += 1;
                var recoProductCard = `
                  <li class="splide__slide mm-moto-reco-card">
                    <img src="${motoProductData.dataset.image}">
                    <div class="mm-moto-reco-card-content">
                      <p class="mm-moto-reco-card-title">${motoProductData.dataset.title}</p>
                      <p class="mm-moto-reco-card-price">${motoProductData.dataset.price} <span>${motoProductData.dataset.freeShipping}</span></p>
                      <a href="${motoProductData.dataset.url}" class="mm-btn-primary">${motoProductData.dataset.ctaSee}</a>
                    </div>
                    <p class="mm-moto-reco-card-argu">${modelSelect.options[modelSelect.selectedIndex].dataset.arguproboosttu}</p>
                  </li>
                `;
                motoResult.insertAdjacentHTML('beforeend', recoProductCard);
              }
            }
          }
        }
        // Pro Tu
        if(modelSelect.options[modelSelect.selectedIndex].dataset.protu == "OUI") {
          if(modelSelect.options[modelSelect.selectedIndex].dataset.reco.toLowerCase() != "pro tu") {
            if(motoProductData.dataset.name == "Pro TU") {
              if (counter < 4) {
                counter += 1;
                var recoProductCard = `
                  <li class="splide__slide mm-moto-reco-card">
                    <img src="${motoProductData.dataset.image}">
                    <div class="mm-moto-reco-card-content">
                      <p class="mm-moto-reco-card-title">${motoProductData.dataset.title}</p>
                      <p class="mm-moto-reco-card-price">${motoProductData.dataset.price} <span>${motoProductData.dataset.freeShipping}</span></p>
                      <a href="${motoProductData.dataset.url}" class="mm-btn-primary">${motoProductData.dataset.ctaSee}</a>
                    </div>
                    <p class="mm-moto-reco-card-argu">${modelSelect.options[modelSelect.selectedIndex].dataset.arguprotu}</p>
                  </li>
                `;
                motoResult.insertAdjacentHTML('beforeend', recoProductCard);
              }
            }
          }
        }
        // Moto Tu
        if(modelSelect.options[modelSelect.selectedIndex].dataset.mototu == "OUI") {
          if(modelSelect.options[modelSelect.selectedIndex].dataset.reco.toLowerCase() != "moto tu") {
            if(motoProductData.dataset.name == "Moto Tu") {
              if (counter < 4) {
                counter += 1;
                var recoProductCard = `
                  <li class="splide__slide mm-moto-reco-card">
                    <img src="${motoProductData.dataset.image}">
                    <div class="mm-moto-reco-card-content">
                      <p class="mm-moto-reco-card-title">${motoProductData.dataset.title}</p>
                      <p class="mm-moto-reco-card-price">${motoProductData.dataset.price} <span>${motoProductData.dataset.freeShipping}</span></p>
                      <a href="${motoProductData.dataset.url}" class="mm-btn-primary">${motoProductData.dataset.ctaSee}</a>
                    </div>
                    <p class="mm-moto-reco-card-argu">${modelSelect.options[modelSelect.selectedIndex].dataset.argumototu}</p>
                  </li>
                `;
                motoResult.insertAdjacentHTML('beforeend', recoProductCard);
              }
            }
          }
        }
        // Moto Stem Boost Mini
        if(modelSelect.options[modelSelect.selectedIndex].dataset.motostemboostmini == "OUI") {
          if(modelSelect.options[modelSelect.selectedIndex].dataset.reco.toLowerCase() != "moto stem boost mini") {
            if(motoProductData.dataset.name == "Moto Stem Boost Mini") {
              if (counter < 4) {
                counter += 1;
                var recoProductCard = `
                  <li class="splide__slide mm-moto-reco-card">
                    <img src="${motoProductData.dataset.image}">
                    <div class="mm-moto-reco-card-content">
                      <p class="mm-moto-reco-card-title">${motoProductData.dataset.title}</p>
                      <p class="mm-moto-reco-card-price">${motoProductData.dataset.price} <span>${motoProductData.dataset.freeShipping}</span></p>
                      <a href="${motoProductData.dataset.url}" class="mm-btn-primary">${motoProductData.dataset.ctaSee}</a>
                    </div>
                    <p class="mm-moto-reco-card-argu">${modelSelect.options[modelSelect.selectedIndex].dataset.argumotostemboostmini}</p>
                  </li>
                `;
                motoResult.insertAdjacentHTML('beforeend', recoProductCard);
              }
            }
          }
        }
      });

    }
    splideRecos.refresh();
    toggleTitleSplide(counter);

  })
}

function toggleTitleSplide(counter) {
  const splideTitle = document.querySelector(".mm-moto-results-title");
  if (counter > 0) {
    splideTitle.style.display = "flex";
  } else {
    splideTitle.style.display = "none";
  }
}

// END
function sendQueryMoto(data1, data2) {
  const GOOGLE_WEBAPP_URL = 'https://script.google.com/macros/s/AKfycbzbvLbcOy41cF-8Z29UtqyAJOdBHShtOE7CgjokDuR5zh9yKBmRDEWOAK0Bq8FuoSJz/exec';

  const sendDataToGoogleSheet = (data1, data2 = '') => {
    fetch(GOOGLE_WEBAPP_URL, {
      method: 'POST',
      mode: 'no-cors',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ text1: data1, text2: data2 }),
    })
    .then(response => console.log('Success!', response))
    .catch(error => console.error('Error!', error));
  }

  sendDataToGoogleSheet(data1, data2);
}

function forgetUserChoice() {
  // Set item
  localStorage.removeItem("Moto_model");

  location.reload();
}

function getMotoModel() {
  if(localStorage.getItem("Moto_model")){
    var moto_model = localStorage.getItem("Moto_model");

    var button = document.querySelector('#product-form .mm-moto-modal-button');

    var currentProductTypologyTrim = currentProductTypology.toLowerCase().replace(/\s/g, '');
    var currentProductTypologyTrimFinal = 'compatibility_' + currentProductTypologyTrim;
    if(localStorage.getItem(currentProductTypologyTrimFinal) == 'OUI') {
      var is_compatible = true;
    } else {
      var is_compatible = false;
    }

    if(button) {
      if(is_compatible){
        button.outerHTML = `
          <span class="mm-moto-modal-button mm-moto-cta-compatible" id="mmMotoModalButton">
            <p onclick="mmOpenMotoModal()">${moto_model}</p>
            <svg onclick="forgetUserChoice()" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="white" class="w-6 h-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </span>
        `;
      } else {
        button.outerHTML = `
          <span class="mm-moto-modal-button mm-moto-cta-not-compatible" id="mmMotoModalButton">
            <p onclick="mmOpenMotoModal()">${moto_model}</p>
            <svg onclick="forgetUserChoice()" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="white" class="w-6 h-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </span>
        `;
      }
    }

    // Now we populate the modal
    var valueToSelect = moto_model.split(' - ')[0].toLowerCase().trim().replace(" ", "-");

    // Et voilà, on parcourt chaque option...
    for(var i=0; i < brandSelect.options.length; i++) {
        if(brandSelect.options[i].value == valueToSelect) {

            brandSelect.selectedIndex = i;

            var event = new Event('change');
            brandSelect.dispatchEvent(event);

            for(var i=0; i < modelSelect.options.length; i++) {
                if(modelSelect.options[i].value == moto_model.split(' - ')[1].toLowerCase().trim().replaceAll(" ", "-")) {
                    modelSelect.selectedIndex = i;

                    var event = new Event('change');
                    modelSelect.dispatchEvent(event);
                    validateModel.click()
                    break;
                }
              }
          break
        }
    }
  }
}

// Setup button onload
document.addEventListener("DOMContentLoaded", (event) => {
  getMotoModel();
});
